/* BASIQ · Slider infinito de reseñas UGC: avanza solo cada X segundos y se puede deslizar.
   Solo avanza mientras se ve en pantalla. */
(function () {
  function setup(vp) {
    if (!vp || vp.dataset.ready === '1') return;
    vp.dataset.ready = '1';

    var track = vp.querySelector('[data-slider-track]');
    var section = vp.closest('.bp-ur') || vp.parentNode;
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-slider-dots] .bp-ur__dot'));
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    var total = originals.length;
    if (total < 2) return;

    /* Copias al final para el bucle infinito (sin atributos del editor) */
    originals.forEach(function (li) {
      var c = li.cloneNode(true);
      c.removeAttribute('data-shopify-editor-block');
      c.setAttribute('aria-hidden', 'true');
      track.appendChild(c);
    });

    var interval = (parseFloat(vp.getAttribute('data-interval')) || 5) * 1000;
    var index = 0;
    var timer = null;
    var paused = false;
    var inView = !('IntersectionObserver' in window);

    function slideWidth() { return originals[0].getBoundingClientRect().width; }

    function render(animate) {
      track.classList.toggle('is-animating', !!animate);
      track.style.transform = 'translate3d(' + (-index * slideWidth()) + 'px, 0, 0)';
      var active = ((index % total) + total) % total;
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === active); });
    }

    function go(i) {
      if (i < 0) {
        /* Hacia atrás desde el primero: saltar a su copia sin animar */
        index = total;
        render(false);
        void track.offsetWidth;
        i = total - 1;
      }
      index = i;
      render(true);
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      if (index >= total) {
        index -= total;
        render(false);
      }
    });

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!paused && inView && !dragging && !document.hidden) {
        timer = setInterval(function () { go(index + 1); }, interval);
      }
    }

    /* Solo avanza cuando la sección está en pantalla */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0.25 }).observe(vp);
    }

    /* Deslizar con el dedo o el ratón */
    var startX = 0, startY = 0, dx = 0, dragging = false, horizontal = null, base = 0;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (index >= total) { index -= total; render(false); }
      dragging = true; horizontal = null; dx = 0;
      startX = e.clientX; startY = e.clientY;
      base = -index * slideWidth();
      stop();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      dx = e.clientX - startX;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(e.clientY - startY) > 6)) {
        horizontal = Math.abs(dx) > Math.abs(e.clientY - startY);
      }
      if (!horizontal) return;
      track.classList.remove('is-animating');
      track.style.transform = 'translate3d(' + (base + dx) + 'px, 0, 0)';
    });
    function end() {
      if (!dragging) return;
      dragging = false;
      var w = slideWidth();
      if (horizontal && dx < -w * 0.15) go(index + 1);
      else if (horizontal && dx > w * 0.15) go(index - 1);
      else render(true);
      start();
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    window.addEventListener('resize', function () { render(false); });

    /* Editor: al seleccionar una reseña, ir a ella y dejar de avanzar */
    section.addEventListener('shopify:block:select', function (e) {
      var n = originals.indexOf(e.target.closest('.bp-ur__slide'));
      if (n > -1) { paused = true; stop(); index = n; render(true); }
    });
    section.addEventListener('shopify:block:deselect', function () { paused = false; start(); });

    render(false);
    start();
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-bp-slider]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
